import type { ImageBlock, LocaleCode } from '@fixit/bozp-content';
import { resolveLocalized } from '../locale';

export function ImageBlockView({ block, locale }: { block: ImageBlock; locale: LocaleCode }) {
  return (
    <figure data-block-type="image">
      <img src={block.src} alt={resolveLocalized(block.alt, locale)} />
      {block.caption ? <figcaption>{resolveLocalized(block.caption, locale)}</figcaption> : null}
    </figure>
  );
}
